import { combineReducers } from "redux";
// import { connectRouter } from "connected-react-router";
import applyCoupon from "../lib/applyCoupon";
import * as fromPrices from "../data/prices";
import mosaic from "./mosaic";
import products from "./products";
import cart from "./cart";
import coupon from "./coupon";
import locale from "./locale";
import alert from "./alert";
import dialog from "./dialog";
import shipping from "./shipping";
import checkout from "./checkout";

const getFreeCopySuccess = (state = false, action) => {
  switch (action.type) {
    case "GET_FREE_COPY_SUCCESS":
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  cart,
  checkout,
  shipping,
  coupon,
  mosaic,
  dialog,
  alert,
  locale,
  products,
  getFreeCopySuccess
});

export const getPrice = ({ productId, optionId, state }) => {
  const { currency } = state.locale;
  return fromPrices.getProductPrice({ currency, productId, optionId });
};
export function cartNeedShipping({ cart, products }) {
  const { cartItems } = cart;
  return cartItems.reduce((bool, { productId }) => {
    const product = products[productId];
    return bool || product.needShipping;
  }, false);
}
export function getCartSubtotal(state) {
  const { cartItems } = state.cart;
  return cartItems.reduce((subtotal, { productId, optionId, quantity }) => {
    return subtotal + quantity * getPrice({ productId, optionId, state });
  }, 0);
}
export function getShippingMethodsWithCosts(state) {
  const { methods, dest } = state.shipping;
  return Object.keys(methods).reduce((obj, id) => {
    obj[id] = methods[id];
    obj[id].cost = getPrice({ id: `${dest}-${id}`, state });
    return obj;
  }, {});
}
export function getShippingCost(state) {
  if (!cartNeedShipping(state)) return 0;
  const {
    cart: { cartItems },
    products,
    shipping
  } = state;
  const { methods, selected, dest } = shipping;
  if (Object.keys(methods).length === 0) return NaN;
  const { currency } = state.locale;
  const weight = cartItems.reduce((w, { quantity, optionId, productId }) => {
    const product = products[productId];
    const option = product.options
      ? product.options.filter(o => o.id === optionId)[0]
      : null;
    let singleWeight;
    if (!isNaN(product.weight)) {
      singleWeight = product.weight;
    } else {
      singleWeight = option.weight;
    }
    return w + quantity * singleWeight;
  }, 0);
  return fromPrices.getShippingCost({
    currency,
    dest,
    method: selected,
    weight
  });
}

export function getOrderSummary(state) {
  const needShipping = cartNeedShipping(state);
  const subtotal = getCartSubtotal(state);

  const shipping = !needShipping ? 0 : getShippingCost(state);
  let discount = 0;

  const { coupon, locale } = state;
  if (coupon.valid) {
    discount = applyCoupon({
      coupon,
      shipping,
      subtotal,
      currency: locale.currency
    });
  }

  const total = Math.max(
    Math.round((subtotal + (isNaN(shipping) ? 0 : shipping) - discount) * 100) /
      100,
    0
  );

  return {
    currency: locale.currency,
    discount,
    shipping,
    subtotal,
    total,
    needShipping
  };
}



// WEBPACK FOOTER //
// ./src/reducers/index.js